import React, { useState } from 'react';
import { Form, Card, Button, Modal, Alert } from 'react-bootstrap';

const AddUsersForm = () => {
  const [formData, setFormData] = useState({
    user: ''
  });

  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let formErrors = {};
    if (!formData.user) {
      formErrors.user = 'User is required';
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setTimeout(() => {
        const isSuccess = Math.random() > 0.5;
        if (isSuccess) {
          setShowSuccessModal(true);
        } else {
          setShowErrorModal(true);
        }
      }, 1000);
    }
  };

  return (
    <Card
      className="shadow-sm rounded-lg mx-auto p-5 d-flex flex-column justify-content-between"
      style={{ maxWidth: '650px', width: '100%', height: '350px' }}
    >
      <h4 className="text-center mb-4">Users</h4>

      <div>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="user" className="mb-4">
            <Form.Label>User</Form.Label>
            <Form.Control
              type="text"
              name="user"
              value={formData.user}
              onChange={handleInputChange}
              isInvalid={!!errors.user}
              placeholder="Enter user name"
            />
            <Form.Control.Feedback type="invalid">
              {errors.user}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </div>

      <div className="d-flex justify-content-between mt-3">
        <Button variant="primary" type="submit" onClick={handleSubmit}>
          Submit
        </Button>
        <Button variant="secondary" type="button">
          Cancel
        </Button>
      </div>

      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
        <Modal.Body>
          <Alert variant="success">Form submitted successfully!</Alert>
        </Modal.Body>
        <Button variant="secondary" onClick={() => setShowSuccessModal(false)}>
          Close
        </Button>
      </Modal>

      <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered>
        <Modal.Body>
          <Alert variant="danger">Failed to submit form. Please try again.</Alert>
        </Modal.Body>
        <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
          Close
        </Button>
      </Modal>
    </Card>
  );
};

export default AddUsersForm;
